import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import axiosInstance from '../../axiosConfig';
import cdiscountLabels from '../../const/cdiscountCategoryLabels.json';

const fetchMarketplaceCategories = async (params) => {
  const { marketplace, ...query } = params;
  try {
    const response = await axiosInstance.get(
      `/marketplaces/${marketplace}/fetch_categories/`,
      { params: query }
    );
    return response.data;
  } catch (error) {
    console.log('Erreur API:', error.response?.status, error.response?.data);
    throw error;
  }
};

export const useGetMarketplaceFetchCategories = (params = {}, options = {}) => {
  const queryParams = useMemo(() => {
    const out = {};
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') out[k] = v;
    });
    return out;
  }, [params]);

  const { data, error, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['marketplace-fetch-categories', queryParams],
    queryFn: () => fetchMarketplaceCategories(queryParams),
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
  });

  const fetchedCategories = useMemo(
    () =>
      (data?.categories || []).map((cat) => ({
        ...cat,
        name: cdiscountLabels[cat.id] || cat.name,
      })),
    [data]
  );

  return {
    fetchedCategories,
    count: data?.count,
    next: data?.next,
    previous: data?.previous,
    error,
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};
